var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 221,
    height: 48,
    viewBox: "0 0 221 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_45_788)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.273 43.7992H87.8751V2.36157H84.7535V46.9168H113.273V43.7992Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.425 2.36169V5.48009H199.161V46.9169H202.282V5.48009H220.019V2.36169H181.425Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.724 2.36157H60.8696V46.9168H57.724V2.36157Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.947 44.0554C136.771 44.0554 128.523 35.337 128.523 24.5802C128.523 13.825 136.771 5.105 146.947 5.105C157.123 5.105 165.371 13.825 165.371 24.5802C165.371 35.337 157.123 44.0554 146.947 44.0554ZM146.959 1.9834C135.054 1.9834 125.404 12.1138 125.404 24.6098C125.404 37.1058 135.054 47.237 146.959 47.237C158.864 47.237 168.514 37.1058 168.514 24.6098C168.514 12.1138 158.864 1.9834 146.959 1.9834Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4547 0.52655C28.7419 0.98575 36.1363 8.63935 36.1363 18.0426L38.6843 0.52655H19.4547Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8499 29.861C26.7675 29.861 31.0675 27.2554 33.4963 23.3722L29.6067 23.3642C27.6691 25.429 24.9163 26.7186 21.8619 26.7186H3.92514V5.48016H14.5907V2.33856H0.779541V46.917H3.92514V29.861H21.8499Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_45_788"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 220.8,
    height: 48,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.10fc0d331df4ac08b2a546ebee2cc5f1.svg";
export { ForwardRef as ReactComponent };